<template>
    <!-- 自定义设计 -->
    <div>
        <el-dialog v-if="dataActionBox.showStatus" :title="dataActionBox.boxTitle+' - 自定义设计'" :visible.sync="dataActionBox.showStatus" append-to-body top="2rem" width="800px" center>
            <div>
                <el-tabs type="border-card" @tab-click="selOrder">
                    <el-tab-pane label="查询头" v-if="formList.jurHead">
                        <div class="design_dis">
                            <el-table v-if="formList.jurHead.jurconfigform" size="mini" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange" height="400"
                                      ref="headTable" :data="formList.jurHead.jurconfigform" border style="width: 100%" :row-key="getRowKey" @row-drag-end="handleHeadDragEnd">
                                <el-table-column type="index" width="50" label="序号"></el-table-column>
                                <el-table-column prop="chineseField" label="字段名称" show-overflow-tooltip width="180">
                                </el-table-column>
                                <el-table-column prop="fieldWeight" label="显示名称">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.showField" size="mini" :disabled="scope.row.isCustomize == 0||customShow"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isShow" label="是否显示">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.isShow" size="mini">
                                            <el-radio-button label="1">是</el-radio-button>
                                            <el-radio-button label="0">否</el-radio-button>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="60" v-if="!customShow">
                                    <template>
                                        <i class="el-icon-rank drag-handle" style="cursor: move; font-size: 16px;" title="可拖拽调整顺序"></i>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="drag-tip" v-if="!customShow">
                            <i class="el-icon-info"></i> 提示：您可以拖拽任意一行来调整顺序
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="主表格头">
                        <div class="design_dis">
                            <el-table v-if="formList.jurTableVo&&formList.jurTableVo.jurconfigtable" size="mini" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                      height="400" ref="mainTable" :data="formList.jurTableVo.jurconfigtable" border style="width: 100%" :row-key="getRowKey" @row-drag-end="handleMainDragEnd">
                                <el-table-column type="index" width="50" label="序号"></el-table-column>
                                <el-table-column prop="chineseField" label="字段名称" show-overflow-tooltip width="180">
                                </el-table-column>
                                <el-table-column prop="fieldWeight" label="显示名称">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.showField" size="mini" :disabled="scope.row.isCustomize == 0||customShow"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isShow" label="是否显示">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.isShow" size="mini" :disabled="scope.row.isCustomize == 0">
                                            <el-radio-button label="1">是</el-radio-button>
                                            <el-radio-button label="0">否</el-radio-button>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column prop="isSort" label="是否排序">
                           <template slot-scope="scope">
                              <el-radio-group v-model="scope.row.isSort" size="mini">
                                 <el-radio-button :label="1">是</el-radio-button>
                                 <el-radio-button :label="0">否</el-radio-button>
                              </el-radio-group>
                           </template>
                        </el-table-column> -->
                                <el-table-column prop="fieldWeight" label="宽度">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.fieldWeight" size="mini" :disabled="scope.row.isCustomize == 0"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="60" v-if="!customShow">
                                    <template>
                                        <i class="el-icon-rank drag-handle" style="cursor: move; font-size: 16px;" title="可拖拽调整顺序"></i>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="drag-tip" v-if="!customShow">
                            <i class="el-icon-info"></i> 提示：您可以拖拽任意一行来调整顺序
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="表单信息" v-if="formList.jurFormVoList.length > 0">
                        <el-tabs v-model="activeName" @tab-click="selForm">
                            <template v-for="(item,index) in formList.jurFormVoList">
                                <el-tab-pane :label="item.jciName" :name="'first'+index" :key="index" v-if="item.jciType != 3">
                                    <div class="design_dis">
                                        <el-table v-if="item.jurconfigform" size="mini" height="400" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                                  :ref="'formTable'+index" :data="item.jurconfigform" border style="width: 100%" :row-key="getRowKey" @row-drag-end="handleFormDragEnd($event, index)">
                                            <el-table-column type="index" width="50" label="序号"></el-table-column>
                                            <el-table-column prop="chineseField" label="字段名称" show-overflow-tooltip width="180">
                                            </el-table-column>
                                            <el-table-column prop="fieldWeight" label="显示名称">
                                                <template slot-scope="scope">
                                                    <el-input v-model="scope.row.showField" size="mini" :disabled="scope.row.isCustomize == 0||customShow"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="isShow" label="是否显示">
                                                <template slot-scope="scope">
                                                    <el-radio-group v-model="scope.row.isShow" size="mini">
                                                        <el-radio-button label="1">是</el-radio-button>
                                                        <el-radio-button label="0">否</el-radio-button>
                                                    </el-radio-group>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="fieldWeight" label="宽度" v-if="item.jciType != 1">
                                                <template slot-scope="scope">
                                                    <el-input v-model="scope.row.fieldWeight" size="mini" :disabled="scope.row.isCustomize == 0"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="操作" width="60" v-if="!customShow">
                                                <template>
                                                    <i class="el-icon-rank drag-handle" style="cursor: move; font-size: 16px;" title="可拖拽调整顺序"></i>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                    <div class="drag-tip" v-if="!customShow">
                                        <i class="el-icon-info"></i> 提示：您可以拖拽任意一行来调整顺序
                                    </div>
                                </el-tab-pane>
                            </template>
                        </el-tabs>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button style="margin-right: 20px;" @click="reSetBtn()">重 置</el-button>
                <el-button @click="dataActionBox.showStatus = false">取 消</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Sortable from 'sortablejs'

export default {
    name: 'customDesign',
    // props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            customShow: window.global_config.customShow,
            dataActionBox: {
                showStatus: false,
                boxTitle: ''
            },
            selectedOptions: [],
            sendDataInfo: {},
            formData: {},
            countryList: [],
            pageType: '',
            formList: [], // 表单
            headData: [], // 查询条件
            activeName: 'first0',
            selectedRow: [],
            selectedDetailsIndex: 0, //主表格索引
            selectedHeadRow: [],
            selectedFormRow0: [],
            selectedFormRow1: [],
            selectedFormRow2: [],
            selectedFormRow3: [],
            selectedFormRow4: [],
            selectedFormRow5: [],
            selectedHeadIndex: 0, //查询表格索引
            selectedIndex0: 0,
            selectedIndex1: 0,
            selectedIndex2: 0,
            selectedIndex3: 0,
            selectedIndex4: 0,
            selectedIndex5: 0,
            selName: 'selectedHeadRow',
            selRef: 'headTable',
            selIndexName: 'selectedHeadIndex',
            jurId: "",
            _uniqueIdCounter: 0, // 唯一ID计数器
            // 存储Sortable实例
            sortableHead: null,
            sortableMain: null,
            sortableForms: [] // 存储多个表单表格的sortable实例
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        // 监听activeName变化，在切换tab时初始化对应表格的拖拽功能
        activeName: {
            handler(newVal) {
                // 延迟执行，确保DOM已更新
                this.$nextTick(() => {
                    // 获取当前激活的表单索引
                    const formIndex = parseInt(newVal.replace('first', ''));
                    if (!isNaN(formIndex)) {
                        this.initSingleFormDrag(formIndex);
                    }
                });
            },
            immediate: false
        }
    },
    //方法集合
    methods: {
        // 生成唯一ID
        generateUniqueId() {
            return `unique_row_id_${this._uniqueIdCounter++}`
        },

        // 确保每行数据都有唯一ID
        ensureUniqueIds(dataArray) {
            if (!dataArray) return
            dataArray.forEach(item => {
                if (!item._uniqueId) {
                    item._uniqueId = this.generateUniqueId()
                }
            })
        },

        // 获取行的唯一key
        getRowKey(row) {
            return row._uniqueId
        },

        // 初始化拖拽功能
        initDrag() {
            this.initHeadDrag()
            this.initMainDrag()
            this.initFormDrag()
        },

        // 初始化查询头拖拽
        initHeadDrag() {
            if (!this.formList.jurHead || !this.formList.jurHead.jurconfigform) return

            // 确保所有行都有唯一ID
            this.ensureUniqueIds(this.formList.jurHead.jurconfigform)

            const headTable = this.$refs.headTable
            if (headTable && headTable.$el) {
                this.sortableHead = Sortable.create(headTable.$el.querySelector('tbody'), {
                    handle: '.drag-handle', // 只能通过拖拽图标进行拖拽
                    onEnd: (evt) => {
                        const oldIndex = evt.oldIndex
                        const newIndex = evt.newIndex

                        // 移动数组元素
                        const movedRow = this.formList.jurHead.jurconfigform.splice(oldIndex, 1)[0]
                        this.formList.jurHead.jurconfigform.splice(newIndex, 0, movedRow)

                        // 更新排序字段
                        this.updateSortOrder(this.formList.jurHead.jurconfigform)
                    }
                })
            }
        },

        // 初始化主表格拖拽
        initMainDrag() {
            if (!this.formList.jurTableVo.jurconfigtable) return

            // 确保所有行都有唯一ID
            this.ensureUniqueIds(this.formList.jurTableVo.jurconfigtable)

            const mainTable = this.$refs.mainTable
            if (mainTable && mainTable.$el) {
                this.sortableMain = Sortable.create(mainTable.$el.querySelector('tbody'), {
                    handle: '.drag-handle', // 只能通过拖拽图标进行拖拽
                    onEnd: (evt) => {
                        const oldIndex = evt.oldIndex
                        const newIndex = evt.newIndex

                        // 移动数组元素
                        const movedRow = this.formList.jurTableVo.jurconfigtable.splice(oldIndex, 1)[0]
                        this.formList.jurTableVo.jurconfigtable.splice(newIndex, 0, movedRow)

                        // 更新排序字段
                        this.updateSortOrder(this.formList.jurTableVo.jurconfigtable)
                    }
                })
            }
        },

        // 初始化表单拖拽
        initFormDrag() {
            if (!this.formList.jurFormVoList) return

            // 清理之前的实例
            this.sortableForms.forEach(instance => {
                if (instance) instance.destroy()
            })
            this.sortableForms = []

            // 为所有表单表格准备初始化，但只对当前激活的tab进行初始化
            this.formList.jurFormVoList.forEach((item, index) => {
                if (!item.jurconfigform) {
                    this.sortableForms[index] = null
                    return
                }

                // 确保所有行都有唯一ID
                this.ensureUniqueIds(item.jurconfigform)

                // 只为当前激活的tab初始化拖拽，其他的在切换时再初始化
                if (this.activeName === `first${index}`) {
                    this.$nextTick(() => {
                        this.initSingleFormDrag(index)
                    })
                }
            })
        },

        // 初始化单个表单表格拖拽
        initSingleFormDrag(index) {
            if (!this.formList.jurFormVoList ||
                !this.formList.jurFormVoList[index] ||
                !this.formList.jurFormVoList[index].jurconfigform) {
                return
            }

            // 确保 DOM 已经渲染
            this.$nextTick(() => {
                // 使用 $nextTick 确保 DOM 已更新
                const formTable = this.$refs[`formTable${index}`]
                if (formTable && Array.isArray(formTable) && formTable.length > 0 && formTable[0].$el) {
                    const tableEl = formTable[0].$el

                    // 检查 tbody 是否存在
                    const tbody = tableEl.querySelector('tbody')
                    if (tbody) {
                        // 如果已有实例，先销毁
                        if (this.sortableForms[index]) {
                            this.sortableForms[index].destroy()
                        }

                        this.sortableForms[index] = Sortable.create(tbody, {
                            handle: '.drag-handle', // 只能通过拖拽图标进行拖拽
                            onEnd: (evt) => {
                                const oldIndex = evt.oldIndex
                                const newIndex = evt.newIndex

                                // 移动数组元素
                                const movedRow = this.formList.jurFormVoList[index].jurconfigform.splice(oldIndex, 1)[0]
                                this.formList.jurFormVoList[index].jurconfigform.splice(newIndex, 0, movedRow)

                                // 更新排序字段
                                this.updateSortOrder(this.formList.jurFormVoList[index].jurconfigform)
                            }
                        })
                    } else {
                        // 如果tbody还没准备好，延迟再试
                        setTimeout(() => {
                            this.initSingleFormDrag(index)
                        }, 100)
                    }
                } else {
                    // 如果DOM还没准备好，延迟再试
                    setTimeout(() => {
                        this.initSingleFormDrag(index)
                    }, 100)
                }
            })
        },

        // 更新排序字段
        updateSortOrder(array) {
            array.forEach((item, index) => {
                item.sort = index + 1
                item.fieldSort = index + 1
            })
        },

        // 处理查询头拖拽结束事件
        handleHeadDragEnd() {
            // 保留此方法以兼容模板中的事件绑定，但实际逻辑已在Sortable的onEnd中处理
        },

        // 处理主表格拖拽结束事件
        handleMainDragEnd() {
            // 保留此方法以兼容模板中的事件绑定，但实际逻辑已在Sortable的onEnd中处理
        },

        // 处理表单拖拽结束事件
        handleFormDragEnd() {
            // 保留此方法以兼容模板中的事件绑定，但实际逻辑已在Sortable的onEnd中处理
        },

        async reSetBtn() {
            this.$confirm('确定要重置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let responseData = await this.$http.jurconfigClearUserJur(
                    { jurId: this.jurId }
                );
                if (responseData.status == 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    this.$parent.getPageInfo()
                    this.dataActionBox.showStatus = false
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }).catch(() => { });
        },

        async sendDataAction() {
            let params = JSON.parse(JSON.stringify(this.formList))
            let responseData = await this.$http.addUserJur(
                params
            );
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$parent.getPageInfo()
                this.dataActionBox.showStatus = false
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        selOrder(e) {
            let selIndex = Number(e.index)
            if (selIndex == 0) {
                this.selName = 'selectedHeadRow'
                this.selRef = 'headTable'
                this.selIndexName = 'selectedHeadIndex'
            } else if (selIndex == 1) {
                this.selName = 'selectedRow'
                this.selRef = 'mainTable'
                this.selIndexName = 'selectedDetailsIndex'
            } else if (selIndex == 2) {
                this.selName = 'selectedFormRow0'
                this.selRef = 'formTable0'
                this.selIndexName = 'selectedIndex0'
            }
        },

        selForm(e) {
            let selFormIndex = Number(e.index)
            this.selName = 'selectedFormRow' + selFormIndex
            this.selRef = 'formTable' + selFormIndex

            // 切换tab时初始化对应表格的拖拽
            this.$nextTick(() => {
                this.initSingleFormDrag(selFormIndex)
            })
        },

        // 移动到最后 集合/组件名/索引变量名
        goBottom(rows) {
            let lg = rows.length - 1
            let index = this[this.selIndexName]
            if (index == lg) return this.$message({
                message: '无法下移',
                type: 'warning'
            })
            rows.splice(index, 1, ...rows.splice(lg, 1, rows[index]));
            this.updateSortOrder(rows)
            this[this.selIndexName] = lg
            this.$nextTick(() => {
                if (this.$refs[this.selRef].length == 1) {
                    let scrollHeight = this.$refs[this.selRef][0].bodyWrapper.scrollHeight
                    this.$refs[this.selRef][0].bodyWrapper.scrollTop = scrollHeight
                    return
                }
                let scrollHeight = this.$refs[this.selRef].bodyWrapper.scrollHeight
                this.$refs[this.selRef].bodyWrapper.scrollTop = scrollHeight
            })
        },

        // 移动到最前
        goTop(rows) {
            let index = this[this.selIndexName]
            if (index == 0) return this.$message({
                message: '无法上移',
                type: 'warning'
            })
            // rows.splice(index, 1, ...rows.splice(0, 1, rows[index]));
            let data = JSON.parse(JSON.stringify(rows[index]))
            rows.splice(index, 1);
            rows.unshift(data)
            this.updateSortOrder(rows)
            this[this.selIndexName] = 0
            this.$nextTick(() => {
                if (this.$refs[this.selRef].length == 1) {
                    this.$refs[this.selRef][0].bodyWrapper.scrollTop = 0
                } else {
                    this.$refs[this.selRef].bodyWrapper.scrollTop = 0
                }
                let refsElTable = this.$refs[this.selRef]; // 获取表格对象
                refsElTable = refsElTable.length == 1 ? this.$refs[this.selRef][0] : this.$refs[this.selRef]
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(rows[this.selectedDetailsIndex]);
            })
        },

        // 下移
        moveDown(rows) {
            let lg = rows.length - 1
            let index = this[this.selIndexName]
            if (index !== lg) {
                rows.splice(index, 1, ...rows.splice(index + 1, 1, rows[index]));
                this.updateSortOrder(rows)
                this[this.selIndexName]++
                this.$nextTick(() => {
                    let refsElTable = this.$refs[this.selRef]; // 获取表格对象
                    refsElTable = refsElTable.length == 1 ? this.$refs[this.selRef][0] : this.$refs[this
                        .selRef]
                    refsElTable.clearSelection();
                    let rowindex = this[this.selIndexName]
                    refsElTable.toggleRowSelection(rows[rowindex]);
                })
            } else {
                return this.$message({
                    message: '无法下移',
                    type: 'warning'
                })
            }
        },

        // 上移
        moveUp(rows) {
            let index = this[this.selIndexName]
            if (index !== 0) {
                rows.splice(index - 1, 1, ...rows.splice(index, 1, rows[index - 1]));
                this.updateSortOrder(rows)
                this[this.selIndexName]--
                this.$nextTick(() => {
                    let refsElTable = this.$refs[this.selRef]; // 获取表格对象
                    refsElTable = refsElTable.length == 1 ? this.$refs[this.selRef][0] : this.$refs[this
                        .selRef]
                    refsElTable.clearSelection();
                    let rowindex = this[this.selIndexName]
                    refsElTable.toggleRowSelection(rows[rowindex]);
                })
            } else {
                return this.$message({
                    message: '无法上移',
                    type: 'warning'
                })
            }
        },

        //初始化
        init() { },

        //父级传入
        openBox(jurId, formList, title) {
            this.jurId = jurId || ''
            this.formList = JSON.parse(JSON.stringify(formList))

            // 初始化唯一ID计数器，使用时间戳加随机数确保唯一性
            if (!this._uniqueIdCounter) {
                this._uniqueIdCounter = new Date().getTime() + Math.floor(Math.random() * 10000)
            }

            // 为所有数据项添加唯一ID
            if (this.formList.jurHead && this.formList.jurHead.jurconfigform) {
                this.ensureUniqueIds(this.formList.jurHead.jurconfigform)
            }
            if (this.formList.jurTableVo && this.formList.jurTableVo.jurconfigtable) {
                this.ensureUniqueIds(this.formList.jurTableVo.jurconfigtable)
            }
            if (this.formList.jurFormVoList) {
                this.formList.jurFormVoList.forEach(item => {
                    if (item.jurconfigform) {
                        this.ensureUniqueIds(item.jurconfigform)
                    }
                })
            }

            var flag = false
            this.formList.jurFormVoList.forEach((item, index) => {
                if (item.jciType != 3) {
                    if (!flag) {
                        flag = true
                        this.activeName = 'first' + index
                    }
                }
            })
            this.dataActionBox.boxTitle = title
            this.dataActionBox.showStatus = true

            this.$nextTick(() => {
                this.initDrag()
            })
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this[this.selName] = rows; // 保存已选择行
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            console.log(row, column, event, params)
            let refsElTable = this.$refs[this.selRef]; // 获取表格对象
            refsElTable = refsElTable.length == 1 ? this.$refs[this.selRef][0] : this.$refs[this.selRef]
            let findRow = {};
            this[this.selIndexName] = row.rowIndex;
            findRow = this[this.selName].find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this[this.selName].length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this[this.selName].find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，给自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
        },
    },

    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },

    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // 确保组件挂载后再初始化拖拽
    },

    beforeCreate() {
        // 创建一个全局ID计数器，使用时间戳加随机数确保唯一性
        if (!this._uniqueIdCounter) {
            this._uniqueIdCounter = Date.now() + Math.floor(Math.random() * 10000)
        }
    }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { //生命周期 - 销毁之前
        // 销毁Sortable实例
        if (this.sortableHead) this.sortableHead.destroy()
        if (this.sortableMain) this.sortableMain.destroy()
        if (this.sortableForms && this.sortableForms.length > 0) {
            this.sortableForms.forEach(instance => {
                if (instance) instance.destroy()
            })
        }
        if (this.formList.jurFormVoList) {
            this.formList.jurFormVoList.forEach((item, index) => {
                if (this[`sortableForm${index}`]) {
                    this[`sortableForm${index}`].destroy()
                }
            })
        }
    },
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.design_dis {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* .sort .box {
		width: 50px;
		height: 40px;
		border: 1px solid #C1C1C1;
	} */
.sort {
    width: 55px;
    margin-left: 14px;
}

.sort .el-button {
    padding: 4px;
    margin-left: 0 !important;
    margin-bottom: 10px;
}

.sort .el-button i {
    font-size: 20px;
}

.el-table .rowStyle {
    background: #fff7ca !important;
}

.drag-handle {
    cursor: move;
}

.drag-tip {
    margin-top: 10px;
    padding: 8px 12px;
    background-color: #f4f4f5;
    border: 1px solid #e9e9eb;
    border-radius: 4px;
    color: #606266;
    font-size: 13px;
}

.drag-tip i {
    color: #909399;
    margin-right: 5px;
}

/* sortable样式 */
.sortable-ghost {
    opacity: 0.4;
}
</style>